import { Container, Icon, Spacer, Text } from 'roadie-ui'
import Panel, { PanelTitle } from 'components/layout/Panel'
import { LocalizedRichText, LocalizedText } from 'localization'
import type { TranslationKey } from 'localization'

const IMPACTS_RATE_KEYS = [
  'dweb_commitment_rate_delayed_removals_after_match',
] as const satisfies readonly TranslationKey[]

const DOES_NOT_IMPACT_RATE_KEYS = [
  'dweb_dashboard_commitment_rate_calculation_section_sender_cancellations',
  'dweb_dashboard_commitment_rate_calculation_section_orders_not_ready_or_in_stock',
  'dweb_dashboard_commitment_rate_calculation_section_long_wait_times_pickup',
  'dweb_dashboard_commitment_rate_calculation_section_declining_add_on_gigs',
] as const satisfies readonly TranslationKey[]

const IconRow: React.FC<{ icon: React.ReactNode; text: React.ReactNode }> = ({ icon, text }) => (
  <Container.Grid $gridTemplateColumns="2rem 1fr" $gridGap="0.8rem" $alignItems="start" $padding="0 0 1.2rem 0">
    {icon}
    <Text.Body2>{text}</Text.Body2>
  </Container.Grid>
)

const CommitmentRateCalculationSection: React.FC = () => (
  <>
    <PanelTitle>
      <LocalizedText translationKey="dweb_dashboard_commitment_rate_calculation_section_how_commitment_rate_calculated" />
    </PanelTitle>
    <Panel left noPadding>
      <Container.Base $padding="2.4rem" $textAlign="left" $color="neutral-black">
        <Text.Body2>
          <LocalizedText translationKey="dweb_dashboard_commitment_rate_calculation_intro" />
        </Text.Body2>

        <Spacer $height="2.4rem" />

        <Container.Grid $gridTemplateColumns="1fr 1fr" $gridGap="2.4rem">
          <div>
            <Text.Body2>
              <LocalizedText translationKey="dweb_dashboard_commitment_rate_calculation_section_impacts_rate" />
            </Text.Body2>
            <Spacer $height="1.2rem" />
            {IMPACTS_RATE_KEYS.map((item) => (
              <IconRow
                key={item}
                icon={<Icon.Checkmark $width="2rem" $height="2rem" $color="neutral-black" />}
                text={<LocalizedText translationKey={item} />}
              />
            ))}
          </div>

          <div>
            <Text.Body2>
              <LocalizedRichText
                translationKey="dweb_dashboard_commitment_rate_calculation_section_does_strong_text1_impact_rate"
                params={{
                  strongText1: (
                    <strong>
                      <LocalizedText translationKey="dweb_dashboard_commitment_rate_calculation_section_not" />
                    </strong>
                  ),
                }}
              />
            </Text.Body2>
            <Spacer $height="1.2rem" />
            {DOES_NOT_IMPACT_RATE_KEYS.map((item) => (
              <IconRow
                key={item}
                icon={<Icon.Close $width="2rem" $height="2rem" $color="neutral-black" />}
                text={<LocalizedText translationKey={item} />}
              />
            ))}
          </div>
        </Container.Grid>
      </Container.Base>
    </Panel>
  </>
)

export default CommitmentRateCalculationSection
